import { Alert } from "@mui/material"
import { useState } from "react"

function isUatSite() {
	return window.location.host.includes('uat');
}

export const BetaWarning = () => {
	const [show] = useState(isUatSite());

	return show ? (
		<Alert 
		icon={false} 
		severity='warning' 
		sx={{
			fontSize: '12px',
			textAlign: 'center',
			padding: '10px 4px',
			position: 'fixed',
			top: 0,
			right: 0,
			zIndex: 2,
			width: '75%',
			borderRadius: '0px'
		}}>
			This is our Beta Website: All submitted information should be for testing purposes.
		</Alert>
	) : null;
}